/**
 * The SalesOrder object is the DTO used by SAP.  It is a combination of multiple objects from the front end
 *
 * @param data
 * @constructor
 */

const SalesOrder = function(data) {
    "use strict";

    let OrderAction,
        Reason,
        ID,
        ExternalID,
        CountryCode,
        SoldToMemberID,
        ProductDiscountCode,
        ShippingDiscountCode,
        CommissionInPriorMonth,     // Backdating, the user gets commission applied to the previous month
        orderProcessingState,
        Custom = [],                     // Array of custom fields to send to sap
        Pricing,                    // Used for loyalty points
        Currency,
        Item,                       // Array of items in cart
        Shipping,
        Payment,
        timeSlotId,
        OrderTotals,
        paRes,
        paymentAuthorizationObject,
        ADROverrideID,
        Category,
        GiftReceipt,
        Date,
        Status;

    // Constructor
    if (data) {
        OrderAction = data.OrderAction;
        Reason = data.Reason;
        ID = data.ID;
        ExternalID = data.ExternalID;
        CountryCode = data.CountryCode;
        SoldToMemberID = data.SoldToMemberID;
        ProductDiscountCode = data.ProductDiscountCode;
        ShippingDiscountCode = data.ShippingDiscountCode;
        CommissionInPriorMonth = data.CommissionableInPriorMonth;
        if (data.orderProcessingState) orderProcessingState = data.orderProcessingState;
        if (data.Custom) Custom = data.Custom;
        Pricing = data.Pricing;
        Currency = data.Currency;
        Item = data.Item;
        Shipping = data.Shipping;
        Payment = data.Payment;
        timeSlotId = data.timeSlotId;
        OrderTotals = data.OrderTotals;
        paRes = data.paRes;
        paymentAuthorizationObject = data.paymentAuthorizationObject;
        ADROverrideID = data.ADROverrideID;
        Category = data.Category;
        if (data.GiftReceipt) GiftReceipt = data.GiftReceipt;
        Date = data.Date;
        Status = data.Status;
    }

    this.toJSON = () => {
        let salesOrderDetail = {
            OrderAction: OrderAction,
            Reason: Reason,
            ID: ID,
            ExternalID: ExternalID,
            CountryCode: CountryCode,
            SoldToMemberID: SoldToMemberID,
            ProductDiscountCode: ProductDiscountCode,
            ShippingDiscountCode: ShippingDiscountCode,
            CommissionInPriorMonth: CommissionInPriorMonth,
            orderProcessingState: orderProcessingState,
            Custom: Custom,
            Pricing: Pricing,
            Currency: Currency,
            Item: Item,
            Shipping: Shipping,
            Payment: Payment,
            timeSlotId: timeSlotId,
            OrderTotals: OrderTotals,
            paRes: paRes,
            paymentAuthorizationObject: paymentAuthorizationObject,
            ADROverrideID: ADROverrideID,
            Category: Category,
            GiftReceipt: GiftReceipt,
            Date: Date,
            Status: Status
        };
        return salesOrderDetail;
    }
    Object.defineProperties(this, {
        OrderAction: {
            get: function () {
                return OrderAction;
            },
            set: function (orderAction) {
                OrderAction = orderAction;
            }
        },
        Reason: {
            get: function () {
                return Reason;
            },
            set: function (reason) {
                Reason = reason;
            }
        },
        ID: {
            get: function () {
                return ID;
            },
            set: function (id) {
                ID = id;
            }
        },
        ExternalID: {
            get: function () {
                return ExternalID;
            },
            set: function (externalID) {
                ExternalID = externalID;
            }
        },
        CountryCode: {
            get: function () {
                return CountryCode;
            },
            set: function (countryCode) {
                CountryCode = countryCode;
            }
        },
        SoldToMemberID: {
            get: function () {
                return SoldToMemberID;
            },
            set: function (soldToMemberID) {
                SoldToMemberID = soldToMemberID;
            }
        },
        ProductDiscountCode: {
            get: function () {
                return ProductDiscountCode;
            },
            set: function (productDiscountCode) {
                ProductDiscountCode = productDiscountCode;
            }
        },
        ShippingDiscountCode: {
            get: function () {
                return ShippingDiscountCode;
            },
            set: function (shippingDiscountCode) {
                ShippingDiscountCode = shippingDiscountCode;
            }
        },
        CommissionInPriorMonth: {
            get: function () {
                return CommissionInPriorMonth;
            },
            set: function (commissionInPriorMonth) {
                CommissionInPriorMonth = commissionInPriorMonth;
            }
        },
        orderProcessingState: {
            get: function () {
                return orderProcessingState;
            },
            set: function (_orderProcessingState) {
                orderProcessingState = _orderProcessingState;
            }
        },
        Custom: {
            get: function () {
                return Custom;
            },
            set: function (custom) {
                Custom = custom;
            }
        },
        Pricing: {
            get: function () {
                return Pricing;
            },
            set: function (pricing) {
                Pricing = pricing;
            }
        },
        Currency: {
            get: function() {
                return Currency;
            },
            set: function(currency) {
                Currency = currency;
            }
        },
        Item: {
            get: function () {
                return Item;
            },
            set: function (item) {
                Item = item;
            }
        },
        Shipping: {
            get: function () {
                return Shipping;
            },
            set: function (shipping) {
                Shipping = shipping;
            }
        },
        Payment: {
            get: function () {
                return Payment;
            },
            set: function (payment) {
                Payment = payment;
            }
        },
        timeSlotId: {
            get: function () {
                return timeSlotId;
            },
            set: function (_timeSlotId) {
                timeSlotId = _timeSlotId;
            }
        },
        OrderTotals: {
            get: function () {
                return OrderTotals;
            },
            set: function (orderTotals) {
                OrderTotals = orderTotals;
            }
        },
        paRes: {
            get: function () {
                return paRes;
            },
            set: function (_paRes) {
                paRes = _paRes;
            }
        },
        paymentAuthorizationObject: {
            get: function () {
                return paymentAuthorizationObject;
            },
            set: function (_paymentAuthorizationObject) {
                paymentAuthorizationObject = _paymentAuthorizationObject;
            }
        },
        ADROverrideID: {
            get: function () {
                return ADROverrideID;
            },
            set: function (adrOverrideID) {
                ADROverrideID = adrOverrideID;
            }
        },
        Category: {
            get: function () {
                return Category;
            },
            set: function (category) {
                Category = category;
            }
        },
        GiftReceipt: {
            get: function () {
                return GiftReceipt;
            },
            set: function (giftReceipt) {
                GiftReceipt = giftReceipt;
            }
        },
        Date: {
            get: function () {
                return Date;
            },
            set: function (date) {
                Date = date;
            }
        },
        Status: {
            get: function () {
                return Status;
            },
            set: function (status) {
                Status = status;
            }
        }
    });
};

export default SalesOrder;
